import React from "react";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";

const SimpleFooter = () => {
  return (
    <div className="relative bg-black w-full h-fit pt-24 sm:pt-20 pb-16">
      <div className="w-full absolute top-0 left-0 right-0">
        <svg
          height="19px"
          viewBox="0 0 1366 19.18"
          preserveAspectRatio="none"
          className="w-full hidden sm:block bg-gray-mtn"
        >
          <path
            d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
            fill="#000"
          ></path>
        </svg>
        <svg
          viewBox="0 0 500 40"
          preserveAspectRatio="xMidYMin meet"
          className="w-full block sm:hidden bg-black"
        >
          <path d="M0,0 Q250,80 500,0 Z" fill="#f2F2F2"></path>
        </svg>
      </div>

      <div className="footer-menu max-w-7xl w-10/12 md:w-10/12 mx-auto hidden sm:flex flex-col items-center">
        <div className="text-white text-xl flex items-center gap-x-10">
          <h2>Nous retrouver :</h2>
          <a
              href="https://web.facebook.com/MTNCotedIvoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookOutlinedIcon sx={{ fontSize: "35px" }} />
            </a>
            <a
              href="https://twitter.com/MTNCotedIvoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon sx={{ fontSize: "35px" }} />
            </a>
            <a
              href="https://www.linkedin.com/company/mtn-ci"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon sx={{ fontSize: "35px" }} />
            </a>
            <a
              href="https://www.youtube.com/@MTNcotedivoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon sx={{ fontSize: "35px" }} />
            </a>
            <a
              href="https://www.instagram.com/mtnci/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ fontSize: "35px" }} />
            </a>
        </div>
        <div className="w-3/5 text-sm text-stone-600 flex items-center justify-evenly mt-8">
          <p>© 2022 MTN Côte d'Ivoire</p>
          <p>Terms and conditions</p>
          <p>Privacy policy</p>
        </div>
      </div>

      <div className="footer-menu max-w-7xl w-10/12 md:w-10/12 mx-auto flex sm:hidden flex-col items-center">
        <div className="text-white text-xl flex flex-col items-center gap-y-4">
          <h2>Nous retrouver :</h2>
          <div className="w-full flex items-center justify-evenly gap-x-8">
            <a
              href="https://web.facebook.com/MTNCotedIvoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookOutlinedIcon sx={{ fontSize: "30px" }} />
            </a>
            <a
              href="https://twitter.com/MTNCotedIvoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon sx={{ fontSize: "30px" }} />
            </a>
            <a
              href="https://www.linkedin.com/company/mtn-ci"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon sx={{ fontSize: "30px" }} />
            </a>
            <a
              href="https://www.youtube.com/@MTNcotedivoire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon sx={{ fontSize: "30px" }} />
            </a>
            <a
              href="https://www.instagram.com/mtnci/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ fontSize: "30px" }} />
            </a>
          </div>
        </div>
        <div className="w-full text-xs text-stone-600 gap-x-5 flex items-center justify-evenly mt-8">
          <p className="text-left">© 2022 MTN Côte d'Ivoire</p>
          <p className="text-center">Terms and conditions</p>
          <p className="text-right">Privacy policy</p>
        </div>
      </div>
    </div>
  );
};

export default SimpleFooter;
